export var SET_CREATOR = 'SET_CREATOR';
export function setCreator(creatorOptions) {
    return function (dispatch) {
        dispatch({
            type: SET_CREATOR,
            payload: creatorOptions,
        });
    };
}
//# sourceMappingURL=setCreator.js.mapexport var SET_CREATOR = 'SET_CREATOR';
export function setCreator(creatorOptions) {
    return function (dispatch) {
        dispatch({
            type: SET_CREATOR,
            payload: creatorOptions,
        });
    };
}
//# sourceMappingURL=setCreator.js.map